import axios from "../axios";

class RoleService {
    getListIdNameAll() {
        return axios.get("role?perPage=1000&fields[role]=id,name");
    }
}

export default new RoleService();
